export const DEFAULT_WORKFLOW_SETTINGS = {
  allow_reentry: false,
  allow_multiple_opportunities: false,
  stop_on_response: false,
  timezone_mode: 'account',
  time_window_enabled: false,
  time_window: {
    days: ['mon', 'tue', 'wed', 'thu', 'fri'],
    start: '09:00',
    end: '17:00',
  },
  default_from_name: '',
  default_from_email: '',
  default_from_number: '',
  mark_as_read: false,
};

export const TIMEZONE_OPTIONS = [
  { value: 'account', label: 'Account timezone' },
  { value: 'contact', label: 'Contact timezone' },
  { value: 'agency', label: 'Agency timezone' },
  { value: 'utc', label: 'UTC' },
];

export function normalizeWorkflowSettings(settings) {
  const merged = { ...DEFAULT_WORKFLOW_SETTINGS, ...(settings || {}) };
  merged.time_window = {
    ...DEFAULT_WORKFLOW_SETTINGS.time_window,
    ...(settings?.time_window || {}),
  };
  return merged;
}
